module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, _vm._l((_vm.picks), function(pick) {
    return _c('div', {
      key: pick.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(pick.title) + "'")]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(pick.date))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pick.content))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(pick.pick))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.side))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.price))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.units))]), _vm._v("\n         \n        "), _c('b', [_vm._v("units")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn red",
      attrs: {
        "to": {
          path: '/admin/pick/' + pick.id
        }
      }
    }, [_vm._v("\n          Edit Pick\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(pick)
        }
      }
    }, [_vm._v("Delete Pick")])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af1b867a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/ManagePicks.vue
// module id = 523
// module chunks = 1